import React, { ReactElement, useEffect, useState } from 'react';
// import styles from './confirm-baggage.module.scss';
import { IntConfirmBaggageProps } from '../../../schemas/baggage.interface';
import { connect, useDispatch } from 'react-redux';
import { IntStore } from '../../../schemas/store.interface';
import { useHistory } from 'react-router-dom';
import { setView } from '../../../core/masterdata/masterdata.reducer';
import { getCompany } from '../../../core/session-storage/session-storage.service';
import { clearConfirm } from './confirm.reducer';
import { useTranslation } from 'react-i18next';
import { showLoading } from '../../../components/ui/loading/loading.reducer';
import { getDeliveris } from  './confirm-baggage.service';

const ConfirmBaggage = (props: IntConfirmBaggageProps): ReactElement => {

  const history = useHistory();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const companyStorage = getCompany();

  const [deliveryData, setDeliveryData]:any = useState({});

  useEffect(()=>{
    async function load() {
      dispatch(showLoading());

      const payload = {
        pir: props.user.userForm.pir,
        recordNumber: props.user.recordNumber,
        language: i18n.language.split('-')[0].toUpperCase()  // 🆕 Solo código corto: ES, EN, FR, etc.
      }      
      const response = await dispatch(getDeliveris(payload, history));
      
      if (response) {
        setDeliveryData(response);
      }
    }
    load();
  },[])

  const getPreferenceLabel = (code: string): string => {
    if (!code) return '';
    
    // Map preference codes to translation keys
    const preferenceMap: { [key: string]: string } = {
      'M': `${companyStorage}.baggage_delivery.preferenciaMañanaLb`,
      'T': `${companyStorage}.baggage_delivery.preferenciatardeLb`,
      'MT': `${companyStorage}.baggage_delivery.preferenciaMañanatardeLb`,
      'TM': `${companyStorage}.baggage_delivery.preferenciaMañanatardeLb`
    };
    
    const translationKey = preferenceMap[code.toUpperCase()];
    return translationKey ? t(translationKey) : code;
  };

  const eventInitBaggage = () => {
    dispatch(setView('user'));
    dispatch(clearConfirm());
    history.push('/' + getCompany() + '/pir');
  };

  return (
    <div data-testid="confirmbaggage">
        <div className="card">
          <h2>{t(`${companyStorage}.baggage_confirm.success_title`)}</h2>
          
          <p>{t(`${companyStorage}.baggage_confirm.success_message`, {
            date: deliveryData.requestDate,
            reference: deliveryData.recordNumber
          })}.</p>
          <br />
          <h3>{t(`${companyStorage}.baggage_confirm.delivery_address_title`)}</h3>
          <ul className="delivery-address" style={{ marginLeft: '40px' }}>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.nombre`)}: </span>
              <span>{deliveryData.fullName?.toUpperCase() || 'N/A'}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.domicilio`)}: </span>
              <span>{deliveryData.homeAddress?.toUpperCase()}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.codigoPostal`)}: </span>
              <span>{deliveryData.postalCode}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.localidad`)}: </span>
              <span>{deliveryData.locality?.toUpperCase()}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.pais`)}: </span>
              <span>{deliveryData.countryName?.toUpperCase() || deliveryData.country?.toUpperCase() || 'N/A'}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.tfno`)}: </span>
              <span>{deliveryData.phone}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.e-mail`)}: </span>
              <span>{deliveryData.email}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.preferencia_de_entrega`)}: </span>
              <span>{getPreferenceLabel(deliveryData.preference)}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.observaciones_adicionales`)}: </span>
              <span>{deliveryData.difficulty}</span>
            </li>
          </ul>
          <br />
          <h3>{t(`${companyStorage}.baggage_confirm.baggage_details_title`)}</h3>
          <ul className="baggage-details" style={{ marginLeft: '40px' }}>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.modelo`)}: </span>
              <span>{deliveryData.baggageModel?.toUpperCase() || 'N/A'}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.tamaño`)}: </span>
              <span>{deliveryData.baggageSize?.toUpperCase() || 'N/A'}</span>
            </li>
            <li>
              <span>{t(`${companyStorage}.baggage_confirm.color`)}: </span>
              <span>{deliveryData.baggageColor?.toUpperCase() || 'N/A'}</span>
            </li>
          </ul>
          <br />
          <h3 className="delivery-notice">{t(`${companyStorage}.baggage_confirm.delivery_notice`)}</h3>
          <br />
          <h3>{t(`${companyStorage}.baggage_confirm.estimated_delivery_title`)}</h3>
          <p>{t(`${companyStorage}.baggage_confirm.estimated_delivery_intro`)}</p>
          <ul className="delivery-times" style={{ marginLeft: '40px' }}>
            <li>{t(`${companyStorage}.baggage_confirm.spain_mainland`)}</li>
            <li>{t(`${companyStorage}.baggage_confirm.balearic_islands`)}</li>
            <li>{t(`${companyStorage}.baggage_confirm.portugal`)}</li>
            <li>{t(`${companyStorage}.baggage_confirm.other_europe`)}</li>
          </ul>
          <p className="delivery-note">{t(`${companyStorage}.baggage_confirm.delivery_note`)}</p>
          <br />
          <h3 className="thank_you">{t(`${companyStorage}.baggage_confirm.thank_you`)}</h3>

          <div className="btn-wrapper">
            <button className="btn btn--primary" id="volver-baggage" onClick={() => eventInitBaggage()}>
              {t(`${companyStorage}.baggage_confirm.btn_volver`)}
            </button>
          </div>
        </div>
    </div>
  );
};

const mapStateToProps = (state: IntStore) => {
  return {
    view: state.masterdata.view,
    confirm: state.confirm,
    user:state.user
  };
};

const mapDispatchToProps = {
  setView,
  getDeliveris
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmBaggage);
